import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

const translations = {
  // ─── Navbar ───
  nav: {
    home: { id: 'Beranda', en: 'Home' },
    directory: { id: 'Direktori Alumni', en: 'Alumni Directory' },
    projects: { id: 'Proyek', en: 'Projects' },
    news: { id: 'Berita', en: 'News' },
    statistics: { id: 'Statistik', en: 'Statistics' },
    about: { id: 'Tentang', en: 'About' },
    admin: { id: 'Kelola', en: 'Manage' },
    adminPanel: { id: 'Panel Pengelola', en: 'Management Panel' },
    alumniRequests: { id: 'Pengajuan Alumni', en: 'Alumni Requests' },
    editRequests: { id: 'Perubahan Data', en: 'Edit Requests' },
    manageNews: { id: 'Kelola Berita', en: 'Manage News' },
    manageProjects: { id: 'Kelola Proyek', en: 'Manage Projects' },
    addAlumni: { id: 'Tambah Alumni', en: 'Add Alumni' },
    emailNotifications: { id: 'Notifikasi Email', en: 'Email Notifications' },
    manageQuiz: { id: 'Kelola Kuis', en: 'Manage Quiz' },
    managePkmBank: { id: 'PKM Bank', en: 'PKM Bank' },
    pkmBank: { id: 'PKM Bank', en: 'PKM Bank' },
    pkmCorner: { id: 'PKM Corner', en: 'PKM Corner' },
    logout: { id: 'Logout', en: 'Logout' },
    applyNow: { id: '+ Ajukan Diri', en: '+ Apply Now' },
    adminLogin: { id: 'Masuk Pengelola', en: 'Manager Login' },
    lightMode: { id: 'Mode Terang', en: 'Light Mode' },
    darkMode: { id: 'Mode Gelap', en: 'Dark Mode' },
    quiz: { id: 'Kuis', en: 'Quiz' },
    trivia: { id: 'Trivia', en: 'Trivia' },
    triviaGames: { id: 'Game & Trivia', en: 'Games & Trivia' },
  },

  // ─── Home ───
  home: {
    badge: { id: 'Pekan Ilmiah Mahasiswa Nasional', en: 'National Student Scientific Week' },
    heroTitle1: { id: 'Jejaring Alumni', en: 'Alumni Network' },
    heroTitle2: { id: 'Indonesia', en: 'Indonesia' },
    heroDesc: { id: 'Menghubungkan para peneliti, inovator, dan pemikir bangsa. Temukan kolega, bangun kolaborasi, dan kembangkan potensimu bersama komunitas alumni PIMNAS.', en: 'Connecting researchers, innovators, and thinkers of the nation. Find colleagues, build collaborations, and develop your potential with the PIMNAS alumni community.' },
    exploreAlumni: { id: 'Jelajahi Alumni', en: 'Explore Alumni' },
    registerYourself: { id: 'Daftarkan Dirimu', en: 'Register Yourself' },
    totalAlumni: { id: 'Total Alumni', en: 'Total Alumni' },
    careerFields: { id: 'Bidang Karir', en: 'Career Fields' },
    eduInstitutions: { id: 'Institusi Pendidikan', en: 'Educational Institutions' },
    pimnasEditions: { id: 'Edisi PIMNAS', en: 'PIMNAS Editions' },
    nationalCompetition: { id: 'Kompetisi Nasional', en: 'National Competition' },
    spotlight: { id: 'Sorotan', en: 'Spotlight' },
    hallOfFame: { id: 'Hall of Fame', en: 'Hall of Fame' },
    hallOfFameDesc: { id: 'Para alumni PIMNAS yang menginspirasi', en: 'Inspiring PIMNAS alumni' },
    viewAll: { id: 'Lihat Semua', en: 'View All' },
    noData: { id: 'Belum ada data alumni.', en: 'No alumni data yet.' },
    addNow: { id: 'Tambahkan sekarang!', en: 'Add now!' },
    latest: { id: 'Terbaru', en: 'Latest' },
    newsActivities: { id: 'Berita & Kegiatan', en: 'News & Activities' },
    newsDesc: { id: 'Update terbaru dari komunitas alumni PIMNAS', en: 'Latest updates from the PIMNAS alumni community' },
    allNews: { id: 'Semua Berita', en: 'All News' },
    noNews: { id: 'Belum ada berita yang dipublikasikan.', en: 'No news published yet.' },
    readMore: { id: 'Baca Selengkapnya', en: 'Read More' },
    joinNow: { id: 'Bergabung Sekarang', en: 'Join Now' },
    ctaTitle1: { id: 'Bergabunglah dengan Jejaring', en: 'Join the Network of' },
    ctaTitle2: { id: 'Alumni PIMNAS', en: 'PIMNAS Alumni' },
    ctaDesc: { id: 'Daftarkan dirimu dan terhubung dengan ratusan alumni PIMNAS di seluruh Indonesia. Bangun kolaborasi riset, mentoring, dan peluang karir bersama.', en: 'Register yourself and connect with hundreds of PIMNAS alumni across Indonesia. Build research collaborations, mentoring, and career opportunities together.' },
    registerNow: { id: 'Daftarkan Dirimu Sekarang', en: 'Register Now' },
    viewStatistics: { id: 'Lihat Statistik', en: 'View Statistics' },
  },

  // ─── Alumni Directory ───
  directory: {
    title: { id: 'Direktori Alumni', en: 'Alumni Directory' },
    subtitle: { id: 'Temukan dan terhubung dengan alumni PIMNAS di seluruh Indonesia', en: 'Find and connect with PIMNAS alumni across Indonesia' },
    searchPlaceholder: { id: 'Cari nama, pekerjaan, instansi, minat riset...', en: 'Search name, job, institution, research interests...' },
    filter: { id: 'Filter', en: 'Filter' },
    addAlumni: { id: '+ Tambah Alumni', en: '+ Add Alumni' },
    applyNow: { id: '+ Ajukan Diri', en: '+ Apply Now' },
    sortBy: { id: 'Urutkan', en: 'Sort By' },
    newest: { id: 'Terbaru', en: 'Newest' },
    oldest: { id: 'Terlama', en: 'Oldest' },
    nameAZ: { id: 'Nama A → Z', en: 'Name A → Z' },
    nameZA: { id: 'Nama Z → A', en: 'Name Z → A' },
    pimnasYear: { id: 'Tahun PIMNAS', en: 'PIMNAS Year' },
    allYears: { id: 'Semua Tahun', en: 'All Years' },
    job: { id: 'Pekerjaan', en: 'Job' },
    allJobs: { id: 'Semua Pekerjaan', en: 'All Jobs' },
    institution: { id: 'Instansi', en: 'Institution' },
    allInstitutions: { id: 'Semua Instansi', en: 'All Institutions' },
    almamaterS1: { id: 'Almamater S1', en: 'S1 Alma Mater' },
    allS1: { id: 'Semua S1', en: 'All S1' },
    campusS2: { id: 'Kampus S2', en: 'S2 Campus' },
    allS2: { id: 'Semua S2', en: 'All S2' },
    allWithS2: { id: 'Semua yang S2', en: 'All with S2' },
    campusS3: { id: 'Kampus S3', en: 'S3 Campus' },
    allS3: { id: 'Semua S3', en: 'All S3' },
    allWithS3: { id: 'Semua yang S3', en: 'All with S3' },
    researchInterest: { id: 'Minat Riset', en: 'Research Interest' },
    allResearch: { id: 'Semua Minat Riset', en: 'All Research Interests' },
    resetFilters: { id: 'Reset Semua Filter', en: 'Reset All Filters' },
    showing: { id: 'Menampilkan', en: 'Showing' },
    of: { id: 'dari', en: 'of' },
    alumni: { id: 'alumni', en: 'alumni' },
    page: { id: 'Hal', en: 'Page' },
    exportCSV: { id: 'Export CSV', en: 'Export CSV' },
    noAlumniFound: { id: 'Tidak ada alumni ditemukan', en: 'No alumni found' },
    tryChanging: { id: 'Coba ubah kata kunci pencarian atau filter', en: 'Try changing the search keywords or filters' },
    edit: { id: 'Edit', en: 'Edit' },
    delete: { id: 'Hapus', en: 'Delete' },
    prev: { id: 'Sebelumnya', en: 'Previous' },
    next: { id: 'Selanjutnya', en: 'Next' },
    confirmDelete: { id: 'Yakin ingin menghapus data alumni ini?', en: 'Are you sure you want to delete this alumni data?' },
  },

  // ─── Alumni Detail ───
  detail: {
    notFound: { id: 'Alumni Tidak Ditemukan', en: 'Alumni Not Found' },
    notFoundDesc: { id: 'Data alumni dengan ID tersebut tidak tersedia.', en: 'Alumni data with that ID is not available.' },
    backToDirectory: { id: 'Kembali ke Direktori Alumni', en: 'Back to Alumni Directory' },
    backToDir: { id: 'Kembali ke Direktori', en: 'Back to Directory' },
    downloadCV: { id: 'Download CV', en: 'Download CV' },
    edit: { id: 'Edit', en: 'Edit' },
    delete: { id: 'Hapus', en: 'Delete' },
    email: { id: 'Email', en: 'Email' },
    education: { id: 'Pendidikan', en: 'Education' },
    career: { id: 'Karir', en: 'Career' },
    onlineProfile: { id: 'Profil Online', en: 'Online Profile' },
    researchInterests: { id: 'Minat Riset / Bidang Keahlian', en: 'Research Interests / Expertise' },
    notFilled: { id: 'Belum diisi', en: 'Not filled' },
    almamaterPimnas: { id: 'Almamater PIMNAS', en: 'PIMNAS Alma Mater' },
    domicile: { id: 'Domisili', en: 'Domicile' },
    at: { id: 'di', en: 'at' },
    confirmDelete: { id: 'Yakin ingin menghapus alumni ini?', en: 'Are you sure you want to delete this alumni?' },
    requestEdit: { id: 'Ajukan Perubahan', en: 'Request Edit' },
    editPending: { id: 'Perubahan Ditinjau', en: 'Edit Under Review' },
  },

  // ─── Statistics ───
  stats: {
    title: { id: 'Statistik Alumni', en: 'Alumni Statistics' },
    subtitle: { id: 'Visualisasi data alumni PIMNAS berdasarkan pekerjaan, pendidikan, dan persebaran domisili', en: 'PIMNAS alumni data visualization by job, education, and domicile distribution' },
    totalAlumni: { id: 'Total Alumni', en: 'Total Alumni' },
    careerFields: { id: 'Bidang Karir', en: 'Career Fields' },
    eduInstitutions: { id: 'Institusi Pendidikan', en: 'Educational Institutions' },
    pimnasEditions: { id: 'Edisi PIMNAS', en: 'PIMNAS Editions' },
    domicileCities: { id: 'Kota Domisili', en: 'Domicile Cities' },
    jobDistribution: { id: 'Distribusi Pekerjaan', en: 'Job Distribution' },
    eduDistribution: { id: 'Distribusi Pendidikan', en: 'Education Distribution' },
    pimnasDistribution: { id: 'Distribusi Alumni per Edisi PIMNAS', en: 'Alumni Distribution per PIMNAS Edition' },
    alumniCount: { id: 'Jumlah Alumni', en: 'Alumni Count' },
    top5Careers: { id: 'Top 5 Bidang Karir', en: 'Top 5 Career Fields' },
    viewAll: { id: 'Lihat Semua', en: 'View All' },
    noData: { id: 'Belum ada data', en: 'No data yet' },
    researchInterests: { id: 'Minat Riset / Bidang Keahlian', en: 'Research Interests / Expertise' },
    alumniMap: { id: 'Peta Persebaran Alumni', en: 'Alumni Distribution Map' },
    alumniFrom: { id: 'alumni dari', en: 'alumni from' },
    citiesOnMap: { id: 'kota tertampil di peta', en: 'cities shown on map' },
    unrecognizedCities: { id: 'kota belum dikenali', en: 'unrecognized cities' },
    alumniLabel: { id: 'alumni', en: 'alumni' },
    others: { id: 'Lainnya', en: 'Others' },
    showAll: { id: 'Tampilkan Semua', en: 'Show All' },
    showLess: { id: 'Tampilkan Sedikit', en: 'Show Less' },
  },

  // ─── News ───
  news: {
    title: { id: 'Berita & Kegiatan', en: 'News & Activities' },
    subtitle: { id: 'Informasi terbaru seputar komunitas alumni PIMNAS Indonesia', en: 'Latest information about the PIMNAS alumni community in Indonesia' },
    noNews: { id: 'Belum Ada Berita', en: 'No News Yet' },
    noNewsDesc: { id: 'Berita dan kegiatan akan muncul di sini setelah dipublikasikan.', en: 'News and activities will appear here after being published.' },
    readMore: { id: 'Baca Selengkapnya', en: 'Read More' },
  },

  // ─── News Detail ───
  newsDetail: {
    backToNews: { id: 'Kembali ke Berita', en: 'Back to News' },
    notFoundTitle: { id: 'Artikel Tidak Ditemukan', en: 'Article Not Found' },
    notFoundDesc: { id: 'Artikel yang Anda cari tidak tersedia atau belum dipublikasikan.', en: 'The article you are looking for is not available or has not been published.' },
    relatedArticles: { id: 'Artikel Terkait', en: 'Related Articles' },
    share: { id: 'Bagikan Artikel', en: 'Share Article' },
    copyLink: { id: 'Salin Link', en: 'Copy Link' },
    copied: { id: 'Tersalin!', en: 'Copied!' },
    copiedMsg: { id: 'Link berhasil disalin! Tempel di Instagram Story atau postingan Anda.', en: 'Link copied! Paste it in your Instagram Story or post.' },
  },

  // ─── Projects ───
  projectsPage: {
    title: { id: 'Program Kerja & Proyek', en: 'Work Programs & Projects' },
    subtitle: { id: 'Daftar program kerja dan proyek ikatan alumni PIMNAS Indonesia', en: 'List of work programs and projects of PIMNAS alumni association Indonesia' },
    searchPlaceholder: { id: 'Cari proyek...', en: 'Search projects...' },
    all: { id: 'Semua', en: 'All' },
    ongoing: { id: 'Berjalan', en: 'Ongoing' },
    completed: { id: 'Selesai', en: 'Completed' },
    planned: { id: 'Rencana', en: 'Planned' },
    noProjects: { id: 'Tidak ada proyek ditemukan.', en: 'No projects found.' },
    visitWebsite: { id: 'Kunjungi Website', en: 'Visit Website' },
  },

  // ─── About ───
  about: {
    title: { id: 'Tentang PIMNAS', en: 'About PIMNAS' },
    subtitle: { id: 'Pekan Ilmiah Mahasiswa Nasional — kompetisi ilmiah paling bergengsi di Indonesia yang menjadi ajang unjuk prestasi mahasiswa terbaik dari seluruh penjuru negeri.', en: 'National Student Scientific Week — the most prestigious scientific competition in Indonesia, showcasing the best student achievements from across the nation.' },
    whatIsPimnas: { id: 'Apa itu PIMNAS?', en: 'What is PIMNAS?' },
    whatIsPimnasDesc1: { id: 'Pekan Ilmiah Mahasiswa Nasional (PIMNAS) adalah kompetisi ilmiah paling bergengsi di Indonesia. Hampir setiap tahunnya, para mahasiswa selalu menunjukkan antusiasme tinggi karena benefit dari mengikuti hingga memenangkan kompetisi ini sangatlah besar.', en: 'National Student Scientific Week (PIMNAS) is the most prestigious scientific competition in Indonesia. Almost every year, students show great enthusiasm because the benefits of participating in and winning this competition are enormous.' },
    whatIsPimnasDesc2: { id: 'PIMNAS merupakan puncak dari Program Kreativitas Mahasiswa (PKM) di mana mahasiswa terbaik dari seluruh Indonesia mempresentasikan hasil riset dan inovasi mereka. Alumni PIMNAS telah tersebar di berbagai sektor: akademia, industri, startup, pemerintahan, dan organisasi internasional.', en: 'PIMNAS is the culmination of the Student Creativity Program (PKM) where the best students from all over Indonesia present their research and innovation results. PIMNAS alumni are spread across various sectors: academia, industry, startups, government, and international organizations.' },
    pimnasHistory: { id: 'Sejarah PIMNAS', en: 'PIMNAS History' },
    fromLKIM: { id: 'Dari LKIM Hingga PIMNAS', en: 'From LKIM to PIMNAS' },
    historyDesc1: { id: 'PIMNAS bermula dari Lomba Karya Tulis Ilmiah (LKTI) dan Lomba Karya Tulis Produktif (LKIP) yang pertama kali terselenggara pada tahun 1988 di Universitas Indonesia (UI). Saat itu, gelaran tersebut masih bernama Lomba Karya Ilmiah Mahasiswa (LKIM).', en: 'PIMNAS originated from the Scientific Writing Competition (LKTI) and Productive Writing Competition (LKIP) first held in 1988 at the University of Indonesia (UI). At that time, the event was still called the Student Scientific Work Competition (LKIM).' },
    historyDesc2: { id: 'Istilah "PIMNAS" pertama kali muncul pada tahun 1990, saat acara terselenggara di Institut Pertanian Bogor (IPB). Selama 16 edisi (1988–2003), belum ada format juara umum.', en: 'The term "PIMNAS" first appeared in 1990, when the event was held at Bogor Agricultural University (IPB). During 16 editions (1988–2003), there was no overall champion format.' },
    historyDesc3: { id: 'Juara umum baru muncul pada PIMNAS ke-17 tahun 2004 di Sekolah Tinggi Teknologi Telkom (STT-Telkom) Bandung. Penyelenggaraan PIMNAS dilaksanakan secara bergilir antara perguruan tinggi negeri dan swasta.', en: 'The overall champion first appeared at the 17th PIMNAS in 2004 at Telkom Institute of Technology (STT-Telkom) Bandung. PIMNAS is held alternately between public and private universities.' },
    pkmProgram: { id: 'Program Kreativitas Mahasiswa', en: 'Student Creativity Program' },
    pkmChanges: { id: 'Perubahan Skema PKM', en: 'PKM Scheme Changes' },
    pkmDesc: { id: 'Sebelum berakhir pada puncak PIMNAS, terdapat kegiatan pendahulu yakni Program Kreativitas Mahasiswa (PKM) yang terus berkembang seiring waktu.', en: 'Before culminating at PIMNAS, there is a preliminary activity called the Student Creativity Program (PKM) which continues to evolve over time.' },
    initialSchemes: { id: 'Awal Mula (5 Skema)', en: 'Initial (5 Schemes)' },
    latestDev: { id: 'Perkembangan Terkini', en: 'Latest Developments' },
    pimnasAward: { id: 'Penghargaan PIMNAS', en: 'PIMNAS Awards' },
    awardDesc1: { id: 'Dalam PIMNAS, terdapat beberapa jenis penghargaan berupa piala, piagam penghargaan, serta penghargaan setara emas, perak, dan perunggu. Piala PIMNAS yang menjadi kebanggaan bernama "Adhikarta Kertawidya".', en: 'In PIMNAS, there are several types of awards including trophies, certificates, and gold, silver, and bronze equivalents. The prestigious PIMNAS trophy is called "Adhikarta Kertawidya".' },
    awardDesc2: { id: 'Pada awalnya, pemenang PIMNAS ditetapkan secara perorangan sehingga tidak ada juara umum. Sejak tahun 2004 (PIMNAS ke-XVII di Bandung), muncul gagasan penetapan juara umum, juara I, dan juara lainnya. Juara umum berhak atas piala bergilir Menteri Pendidikan dan Kebudayaan "Adhikarta Kertawidya".', en: 'Initially, PIMNAS winners were determined individually so there was no overall champion. Since 2004 (17th PIMNAS in Bandung), the concept of overall champion emerged. The overall champion receives the rotating Minister of Education and Culture trophy "Adhikarta Kertawidya".' },
    awardDesc3: { id: 'Penyelenggaraan PIMNAS dilaksanakan secara bergilir antara perguruan tinggi negeri dan swasta dengan mempertimbangkan faktor kesiapan.', en: 'PIMNAS is organized alternately between public and private universities, considering readiness factors.' },
    adhikartaDesc: { id: 'Piala bergilir Menteri Pendidikan dan Kebudayaan untuk Juara Umum PIMNAS', en: 'Rotating trophy of the Minister of Education and Culture for PIMNAS Overall Champion' },
    timeline: { id: 'Perjalanan PIMNAS & PKM', en: 'PIMNAS & PKM Journey' },
    timelineDesc: { id: 'Tonggak-tonggak penting dalam sejarah PIMNAS', en: 'Important milestones in PIMNAS history' },
    ourValues: { id: 'Nilai-Nilai Kami', en: 'Our Values' },
    valuesDesc: { id: 'Prinsip yang menjadi fondasi komunitas alumni PIMNAS', en: 'Principles that form the foundation of the PIMNAS alumni community' },
    collaboration: { id: 'Kolaborasi', en: 'Collaboration' },
    collaborationDesc: { id: 'Membangun kerjasama lintas disiplin ilmu dan universitas untuk menghasilkan dampak nyata.', en: 'Building cooperation across disciplines and universities to create real impact.' },
    innovation: { id: 'Inovasi', en: 'Innovation' },
    innovationDesc: { id: 'Mendorong pengembangan ide-ide riset menjadi solusi nyata bagi masyarakat Indonesia.', en: 'Encouraging the development of research ideas into real solutions for Indonesian society.' },
    dedication: { id: 'Dedikasi', en: 'Dedication' },
    dedicationDesc: { id: 'Berkomitmen pada kemajuan ilmu pengetahuan dan pengabdian untuk bangsa.', en: 'Committed to advancing science and serving the nation.' },
    acceleration: { id: 'Akselerasi', en: 'Acceleration' },
    accelerationDesc: { id: 'Mempercepat pertumbuhan karir alumni melalui mentoring dan jejaring profesional.', en: 'Accelerating alumni career growth through mentoring and professional networking.' },
  },

  // ─── Footer ───
  footer: {
    totalVisits: { id: 'Total Kunjungan', en: 'Total Visits' },
    today: { id: 'Hari Ini', en: 'Today' },
    uniqueVisitors: { id: 'Pengunjung Unik', en: 'Unique Visitors' },
    desc: { id: 'Menghubungkan para alumni PIMNAS dari seluruh Indonesia. Membangun jejaring, berbagi inspirasi, dan mendorong inovasi bersama.', en: 'Connecting PIMNAS alumni from across Indonesia. Building networks, sharing inspiration, and driving innovation together.' },
    navigation: { id: 'Navigasi', en: 'Navigation' },
    home: { id: 'Beranda', en: 'Home' },
    directory: { id: 'Direktori Alumni', en: 'Alumni Directory' },
    newsArticles: { id: 'Berita & Artikel', en: 'News & Articles' },
    statistics: { id: 'Statistik', en: 'Statistics' },
    aboutUs: { id: 'Tentang Kami', en: 'About Us' },
    contactUs: { id: 'Kontak Kami', en: 'Contact Us' },
    socialMedia: { id: 'Media Sosial', en: 'Social Media' },
    copyright: { id: 'Ikatan Alumni PIMNAS. All rights reserved.', en: 'PIMNAS Alumni Association. All rights reserved.' },
    madeWith: { id: 'Dibangun dengan ❤️ untuk komunitas riset Indonesia', en: 'Built with ❤️ for Indonesia\'s research community' },
  },

  // ─── Login ───
  login: {
    title: { id: 'Admin Login', en: 'Admin Login' },
    subtitle: { id: 'Masuk untuk mengelola data alumni PIMNAS', en: 'Login to manage PIMNAS alumni data' },
    email: { id: 'Email', en: 'Email' },
    password: { id: 'Password', en: 'Password' },
    passwordPlaceholder: { id: 'Masukkan password', en: 'Enter password' },
    loginBtn: { id: 'Masuk', en: 'Login' },
    loggingIn: { id: 'Memproses...', en: 'Processing...' },
    error: { id: 'Email atau password salah. Pastikan akun sudah terdaftar.', en: 'Wrong email or password. Make sure your account is registered.' },
  },

  // ─── Request Alumni ───
  request: {
    title: { id: 'Ajukan Diri sebagai Alumni', en: 'Apply as Alumni' },
    subtitle: { id: 'Data kamu akan ditinjau oleh admin sebelum ditampilkan di direktori', en: 'Your data will be reviewed by admin before being displayed in the directory' },
    infoBox: { id: 'Pengajuan kamu akan masuk ke daftar review. Setelah disetujui, data kamu akan muncul di direktori alumni PIMNAS.', en: 'Your application will be added to the review list. Once approved, your data will appear in the PIMNAS alumni directory.' },
    backToDirectory: { id: 'Kembali ke Direktori', en: 'Back to Directory' },
    fullName: { id: 'Nama Lengkap', en: 'Full Name' },
    pimnasParticipation: { id: 'Partisipasi PIMNAS', en: 'PIMNAS Participation' },
    pimnasEdition: { id: 'PIMNAS ke-', en: 'PIMNAS Edition' },
    pimnasHint: { id: 'Nomor edisi PIMNAS yang kamu ikuti', en: 'PIMNAS edition number you participated in' },
    educationHistory: { id: 'Riwayat Pendidikan', en: 'Education History' },
    fillRelevant: { id: 'Isi yang relevan saja', en: 'Fill in relevant ones only' },
    campus: { id: 'Kampus', en: 'University' },
    major: { id: 'Jurusan / Prodi', en: 'Major / Department' },
    s1Almamater: { id: 'S1 — Almamater PIMNAS', en: 'Bachelor — PIMNAS Alma Mater' },
    s2Master: { id: 'S2 — Magister', en: 'Master\'s Degree' },
    s3Doctor: { id: 'S3 — Doktoral', en: 'Doctoral Degree' },
    careerSection: { id: 'Karir & Pekerjaan', en: 'Career & Employment' },
    jobTitle: { id: 'Pekerjaan / Jabatan', en: 'Job / Position' },
    workplace: { id: 'Instansi / Tempat Kerja', en: 'Institution / Workplace' },
    researchInterests: { id: 'Minat Riset / Bidang Keahlian', en: 'Research Interests / Expertise' },
    researchHint: { id: 'Pisahkan dengan koma jika lebih dari satu bidang', en: 'Separate with commas if more than one field' },
    currentDomicile: { id: 'Domisili Saat Ini', en: 'Current Domicile' },
    domicileHint: { id: 'Kota tempat tinggal saat ini — untuk peta persebaran alumni', en: 'Current city of residence — for alumni distribution map' },
    messageToAdmin: { id: 'Pesan untuk Admin', en: 'Message for Admin' },
    submit: { id: 'Kirim Pengajuan', en: 'Submit Application' },
    submitting: { id: 'Mengirim...', en: 'Submitting...' },
    optional: { id: 'Opsional', en: 'Optional' },
    successTitle: { id: 'Pengajuan Terkirim!', en: 'Application Submitted!' },
    successDesc: { id: 'Terima kasih', en: 'Thank you' },
    successDesc2: { id: 'Pengajuan kamu sedang ditinjau oleh admin. Kamu akan ditambahkan ke direktori alumni setelah disetujui.', en: 'Your application is being reviewed by admin. You will be added to the alumni directory once approved.' },
    viewDirectory: { id: 'Lihat Direktori Alumni', en: 'View Alumni Directory' },
    uploadPhoto: { id: 'Upload Foto', en: 'Upload Photo' },
    photoSizeError: { id: 'Ukuran foto maksimal 1 MB. Silakan kompres atau pilih foto lain.', en: 'Maximum photo size is 1 MB. Please compress or choose another photo.' },
    nameRequired: { id: 'Nama lengkap wajib diisi.', en: 'Full name is required.' },
    submitError: { id: 'Gagal mengirim pengajuan', en: 'Failed to submit application' },
  },

  // ─── Edit Request ───
  editRequest: {
    title: { id: 'Ajukan Perubahan Data', en: 'Request Data Change' },
    subtitle: { id: 'Perubahan akan ditinjau oleh admin sebelum diterapkan', en: 'Changes will be reviewed by admin before being applied' },
    infoBox: { id: 'Ubah data yang ingin diperbarui. Setelah diajukan, admin akan meninjau dan menyetujui perubahan. Anda hanya bisa mengajukan satu kali sampai admin selesai meninjau.', en: 'Modify the data you want to update. After submission, admin will review and approve the changes. You can only submit once until admin finishes reviewing.' },
    changePhoto: { id: 'Ganti Foto', en: 'Change Photo' },
    reasonLabel: { id: 'Alasan Perubahan', en: 'Reason for Change' },
    reasonPlaceholder: { id: 'Jelaskan alasan perubahan data (misal: update pekerjaan baru, pindah domisili, dll)', en: 'Explain the reason for the data change (e.g., new job update, moved to new city, etc.)' },
    submit: { id: 'Kirim Permintaan Perubahan', en: 'Submit Change Request' },
    submitError: { id: 'Gagal mengirim permintaan perubahan', en: 'Failed to submit change request' },
    successTitle: { id: 'Permintaan Terkirim!', en: 'Request Submitted!' },
    successDesc: { id: 'Permintaan perubahan data kamu sedang ditinjau oleh admin. Data akan diperbarui setelah disetujui.', en: 'Your data change request is being reviewed by admin. Data will be updated once approved.' },
    backToProfile: { id: 'Kembali ke Profil', en: 'Back to Profile' },
    pendingTitle: { id: 'Permintaan Sedang Ditinjau', en: 'Request Under Review' },
    pendingDesc: { id: 'Kamu sudah mengajukan perubahan data yang sedang ditinjau admin. Silakan tunggu sampai admin menyelesaikan peninjauan sebelum mengajukan lagi.', en: 'You have already submitted a data change request that is being reviewed by admin. Please wait until admin finishes reviewing before submitting again.' },
  },

  // ─── Quiz ───
  quiz: {
    title: { id: 'Trivia PIMNAS', en: 'PIMNAS Trivia' },
    subtitle: { id: 'Uji pengetahuanmu tentang PIMNAS & PKM!', en: 'Test your knowledge about PIMNAS & PKM!' },
    howToPlay: { id: 'Cara Main', en: 'How to Play' },
    rule1: { id: '10 soal acak seputar PIMNAS dan PKM', en: '10 random questions about PIMNAS and PKM' },
    rule2: { id: '15 detik per soal — makin cepat makin besar poin!', en: '15 seconds per question — faster = more points!' },
    rule3: { id: 'Bonus poin untuk jawaban cepat', en: 'Bonus points for fast answers' },
    rule4: { id: 'Streak 3x & 5x jawaban benar = bonus ekstra!', en: '3x & 5x correct streak = extra bonus!' },
    yourName: { id: 'Nama Kamu', en: 'Your Name' },
    namePlaceholder: { id: 'Masukkan nama kamu...', en: 'Enter your name...' },
    startGame: { id: 'Mulai Kuis!', en: 'Start Quiz!' },
    timesUp: { id: 'Waktu habis!', en: "Time's up!" },
    points: { id: 'poin', en: 'points' },
    correct: { id: 'Benar', en: 'Correct' },
    bestStreak: { id: 'Streak Terbaik', en: 'Best Streak' },
    time: { id: 'Waktu', en: 'Time' },
    rank: { id: 'Peringkat', en: 'Rank' },
    playAgain: { id: 'Main Lagi', en: 'Play Again' },
    backToHome: { id: 'Kembali ke Beranda', en: 'Back to Home' },
    leaderboard: { id: 'Papan Peringkat', en: 'Leaderboard' },
    globalLeaderboard: { id: 'Papan Peringkat Global', en: 'Global Leaderboard' },
    you: { id: 'Kamu', en: 'You' },
    gradeLegend: { id: '🏆 Kamu Legenda PIMNAS!', en: '🏆 You\'re a PIMNAS Legend!' },
    gradeExcellent: { id: '🌟 Luar Biasa!', en: '🌟 Excellent!' },
    gradeGood: { id: '👍 Bagus!', en: '👍 Good Job!' },
    gradeKeepLearning: { id: '📚 Terus Belajar!', en: '📚 Keep Learning!' },
    gradeTryAgain: { id: '💪 Coba Lagi!', en: '💪 Try Again!' },
  },

  // ─── Trivia Page ───
  trivia: {
    title: { id: 'Trivia PIMNAS', en: 'PIMNAS Trivia' },
    subtitle: { id: 'Pilih game favoritmu dan mainkan!', en: 'Pick your favorite game and play!' },
    tabQuiz: { id: 'Kuis PIMNAS', en: 'PIMNAS Quiz' },
    tabGuess: { id: 'Tebak Alumni', en: 'Guess the Alumni' },
    tabCatch: { id: 'Catch Me', en: 'Catch Me' },
  },

  // ─── Guess Alumni ───
  guess: {
    title: { id: 'Tebak Alumni', en: 'Guess the Alumni' },
    subtitle: { id: 'Tebak siapa alumni PIMNAS dari petunjuk yang diberikan!', en: 'Guess which PIMNAS alumni from the given clues!' },
    howToPlay: { id: 'Cara Main', en: 'How to Play' },
    rule1: { id: 'Setiap ronde, 1 petunjuk langsung diberikan secara gratis!', en: 'Each round, 1 clue is given for free!' },
    rule2: { id: 'Butuh petunjuk lagi? Buka dengan kuota ekstra (total 10 sepanjang game)', en: 'Need more clues? Use your extra quota (10 total across the game)' },
    rule3: { id: '30 detik per ronde — makin sedikit petunjuk, makin besar skor!', en: '30 seconds per round — fewer clues = higher score!' },
    rule4: { id: '8 ronde total, streak bonus untuk jawaban beruntun!', en: '8 rounds total, streak bonus for consecutive answers!' },
    startGame: { id: 'Mulai Tebak!', en: 'Start Guessing!' },
  },

  // ─── Catch Me Game ───
  catchMe: {
    title: { id: 'Catch Me!', en: 'Catch Me!' },
    subtitle: { id: 'Kejar Piala Adhikarta Kertawidya! Hindari rintangan & jawab kuis!', en: 'Chase the Adhikarta Kertawidya Trophy! Dodge obstacles & answer quizzes!' },
    howToPlay: { id: 'Cara Main', en: 'How to Play' },
    rule1: { id: 'Klik / Tap / Spasi untuk melompati rintangan', en: 'Click / Tap / Space to jump over obstacles' },
    rule2: { id: 'Kejar piala 🏆 yang selalu berada di depanmu!', en: 'Chase the trophy 🏆 that\'s always ahead!' },
    rule3: { id: 'Setiap 10 poin, jawab kuis untuk membuka gerbang!', en: 'Every 10 points, answer a quiz to open the gate!' },
    rule4: { id: 'Semakin tinggi skor, semakin cepat! Jawab salah = game over!', en: 'Higher score = faster speed! Wrong answer = game over!' },
    startGame: { id: 'Mulai!', en: 'Start!' },
    gateTitle: { id: 'Gerbang Kuis!', en: 'Quiz Gate!' },
    gateHint: { id: 'Jawab dengan benar untuk melanjutkan', en: 'Answer correctly to continue' },
    gatesCleared: { id: 'Gerbang', en: 'Gates' },
    controlHint: { id: 'Klik / Tap / Spasi untuk lompat', en: 'Click / Tap / Space to jump' },
  },

  // ─── PKM Features Hub ───
  pkmFeatures: {
    title: { id: 'PKM Corner', en: 'PKM Corner' },
    subtitle: { id: 'Semua yang kamu butuhkan untuk menyusun proposal PKM dan lolos hingga PIMNAS', en: 'Everything you need to prepare your PKM proposal and make it to PIMNAS' },
    bankTitle: { id: 'PKM Bank', en: 'PKM Bank' },
    bankDesc: { id: 'Akses kumpulan template dan contoh proposal PKM dari alumni yang telah lolos PIMNAS. Ajukan akses dan dapatkan referensi langsung di Google Drive.', en: 'Access a collection of PKM proposal templates from alumni who passed PIMNAS. Request access and get references directly on Google Drive.' },
    bankCta: { id: 'Ajukan Akses', en: 'Request Access' },
    builderTitle: { id: 'Build Your PKM Proposal', en: 'Build Your PKM Proposal' },
    builderDesc: { id: 'Bangun tim, dapatkan rekomendasi komposisi jurusan yang ideal dari AI, dan pilih jenis PKM yang paling cocok untuk timmu.', en: 'Build your team, get AI-powered recommendations for ideal major composition, and choose the PKM type that fits your team best.' },
    builderCta: { id: 'Mulai Sekarang', en: 'Start Now' },
    badgeTemplates: { id: 'Template Proposal', en: 'Proposal Templates' },
    badgeTeam: { id: 'Team Builder', en: 'Team Builder' },
    infoTitle: { id: 'Jenis-jenis PKM', en: 'PKM Types' },
    infoDesc: { id: 'PKM (Program Kreativitas Mahasiswa) memiliki berbagai skema yang bisa dipilih sesuai minat dan keahlian tim kamu. Pahami masing-masing jenis untuk menentukan proposal terbaik.', en: 'PKM (Student Creativity Program) has various schemes that can be chosen according to your team\'s interests and expertise. Understand each type to determine the best proposal.' },
  },

  // ─── PKM Builder ───
  pkmBuilder: {
    title: { id: 'Build Your PKM Proposal', en: 'Build Your PKM Proposal' },
    subtitle: { id: 'Susun tim, dapatkan rekomendasi AI, dan pilih jenis PKM', en: 'Build your team, get AI recommendations, and choose PKM type' },
    backToCorner: { id: 'Kembali ke PKM Corner', en: 'Back to PKM Corner' },
    stepTeam: { id: 'Bangun Tim', en: 'Build Team' },
    stepAI: { id: 'Rekomendasi AI', en: 'AI Recommendation' },
    stepPKM: { id: 'Pilih PKM', en: 'Choose PKM' },
    teamTitle: { id: 'Anggota Tim', en: 'Team Members' },
    teamDesc: { id: 'Masukkan data anggota tim kamu (minimal 2, maksimal 5 orang). Ketua tim ada di urutan pertama.', en: 'Enter your team member data (minimum 2, maximum 5 people). Team leader is first.' },
    leader: { id: 'Ketua Tim', en: 'Team Leader' },
    member: { id: 'Anggota', en: 'Member' },
    namePh: { id: 'Nama lengkap', en: 'Full name' },
    majorPh: { id: 'Jurusan', en: 'Major' },
    campusPh: { id: 'Kampus', en: 'University' },
    addMember: { id: 'Tambah Anggota', en: 'Add Member' },
    ideaTitle: { id: 'Tema & Judul', en: 'Theme & Title' },
    ideaDesc: { id: 'Ceritakan rencana tema penelitian atau inovasi yang ingin dikembangkan.', en: 'Describe the research theme or innovation plan you want to develop.' },
    themeLabel: { id: 'Tema / Topik', en: 'Theme / Topic' },
    themePh: { id: 'Contoh: Pemanfaatan AI untuk deteksi dini penyakit tanaman', en: 'Example: Using AI for early detection of plant diseases' },
    titleLabel: { id: 'Rencana Judul', en: 'Planned Title' },
    titlePh: { id: 'Judul proposal yang direncanakan', en: 'Planned proposal title' },
    getRecommendation: { id: 'Dapatkan Rekomendasi AI', en: 'Get AI Recommendation' },
    yourTeam: { id: 'Tim Kamu', en: 'Your Team' },
    aiTitle: { id: 'Rekomendasi AI', en: 'AI Recommendation' },
    aiLoading: { id: 'AI sedang menganalisis tim kamu...', en: 'AI is analyzing your team...' },
    aiLoadingDesc: { id: 'Mohon tunggu beberapa saat...', en: 'Please wait a moment...' },
    retry: { id: 'Coba lagi', en: 'Try again' },
    editTeam: { id: 'Edit Tim', en: 'Edit Team' },
    choosePKM: { id: 'Pilih Jenis PKM', en: 'Choose PKM Type' },
    choosePKMTitle: { id: 'Pilih Jenis PKM', en: 'Choose PKM Type' },
    choosePKMDesc: { id: 'Pilih jenis PKM yang akan kamu ikuti berdasarkan rekomendasi AI dan minat tim.', en: 'Choose the PKM type you will participate in based on AI recommendations and team interests.' },
    backToAI: { id: 'Lihat Rekomendasi', en: 'View Recommendation' },
    finish: { id: 'Selesai', en: 'Finish' },
    doneTitle: { id: 'Persiapan Selesai! 🎉', en: 'Preparation Done! 🎉' },
    doneDesc: { id: 'Tim kamu sudah siap untuk menyusun proposal PKM. Gunakan rekomendasi AI dan template dari PKM Bank sebagai referensi.', en: 'Your team is ready to prepare the PKM proposal. Use AI recommendations and templates from PKM Bank as reference.' },
    summary: { id: 'Ringkasan', en: 'Summary' },
    pkmType: { id: 'Jenis PKM', en: 'PKM Type' },
    teamSize: { id: 'Jumlah Anggota', en: 'Team Size' },
    openBank: { id: 'Buka PKM Bank', en: 'Open PKM Bank' },
    stepMatch: { id: 'Match Alumni', en: 'Match Alumni' },
    findMentor: { id: 'Cari Mentor Alumni', en: 'Find Alumni Mentor' },
    matchTitle: { id: 'Alumni Mentor Matching', en: 'Alumni Mentor Matching' },
    matchDesc: { id: 'AI akan mencocokkan riset kamu dengan alumni PIMNAS yang relevan sebagai mentor potensial.', en: 'AI will match your research with relevant PIMNAS alumni as potential mentors.' },
    matchScanning: { id: 'Memindai database alumni...', en: 'Scanning alumni database...' },
    matchAnalyzing: { id: 'AI sedang menganalisis kecocokan...', en: 'AI is analyzing matches...' },
    matchNoResult: { id: 'Belum ada alumni yang cocok ditemukan. Coba perluas tema riset kamu.', en: 'No matching alumni found. Try broadening your research theme.' },
    matchFound: { id: 'Ditemukan {count} alumni yang cocok', en: 'Found {count} matching alumni' },
    viewProfile: { id: 'Lihat Profil', en: 'View Profile' },
    backToPKM: { id: 'Kembali', en: 'Back' },
  },

  // ─── PKM Bank (Public) ───
  pkmBank: {
    title: { id: 'PKM Bank', en: 'PKM Bank' },
    subtitle: { id: 'Akses kumpulan template PKM yang telah lolos PIMNAS', en: 'Access collection of PKM templates that passed PIMNAS' },
    infoTitle: { id: 'Apa itu PKM Bank?', en: 'What is PKM Bank?' },
    infoDesc: { id: 'PKM Bank adalah kumpulan template dan contoh proposal PKM dari alumni yang telah lolos hingga PIMNAS. Ajukan akses dengan mengisi formulir di bawah, dan setelah disetujui, admin akan menambahkan email kamu ke Google Drive koleksi template PKM.', en: 'PKM Bank is a collection of PKM proposal templates from alumni who have passed to PIMNAS. Request access by filling out the form below, and once approved, admin will add your email to the PKM template collection Google Drive.' },
    name: { id: 'Nama Lengkap', en: 'Full Name' },
    namePlaceholder: { id: 'Masukkan nama lengkap', en: 'Enter your full name' },
    email: { id: 'Email (Google)', en: 'Email (Google)' },
    emailPlaceholder: { id: 'contoh@gmail.com', en: 'example@gmail.com' },
    emailHint: { id: 'Gunakan email Google agar bisa langsung diakses di Google Drive', en: 'Use a Google email so it can be directly accessed on Google Drive' },
    campus: { id: 'Kampus / Universitas', en: 'University / Campus' },
    campusPlaceholder: { id: 'Nama kampus kamu', en: 'Your university name' },
    major: { id: 'Jurusan / Prodi', en: 'Major / Department' },
    majorPlaceholder: { id: 'Jurusan atau program studi', en: 'Major or study program' },
    batch: { id: 'Angkatan', en: 'Batch / Year' },
    batchPlaceholder: { id: 'Contoh: 2023', en: 'Example: 2023' },
    reason: { id: 'Alasan Mengajukan Akses', en: 'Reason for Requesting Access' },
    reasonPlaceholder: { id: 'Ceritakan mengapa kamu ingin akses ke PKM Bank, misal: sedang menyusun proposal PKM-RE untuk PIMNAS ke-39...', en: 'Tell us why you want access to PKM Bank, e.g.: currently preparing a PKM-RE proposal for PIMNAS 39th...' },
    submit: { id: 'Kirim Pengajuan', en: 'Submit Request' },
    submitting: { id: 'Mengirim...', en: 'Submitting...' },
    allFieldsRequired: { id: 'Semua field wajib diisi.', en: 'All fields are required.' },
    submitError: { id: 'Gagal mengirim pengajuan', en: 'Failed to submit request' },
    successTitle: { id: 'Pengajuan Terkirim! 🎉', en: 'Request Submitted! 🎉' },
    successDesc: { id: 'Terima kasih telah mengajukan akses ke PKM Bank.', en: 'Thank you for requesting access to PKM Bank.' },
    successDesc2: { id: 'Admin akan meninjau pengajuan kamu dan menambahkan email ke Google Drive jika disetujui. Tunggu notifikasi dari Google Drive ya!', en: 'Admin will review your request and add your email to Google Drive if approved. Wait for a notification from Google Drive!' },
    backToHome: { id: 'Kembali ke Beranda', en: 'Back to Home' },
  },

  // ─── PKM Bank Admin ───
  pkmBankAdmin: {
    title: { id: 'Permintaan Akses PKM Bank', en: 'PKM Bank Access Requests' },
    subtitle: { id: 'Kelola permintaan akses ke kumpulan template PKM', en: 'Manage access requests to PKM template collection' },
    filterAll: { id: 'Semua', en: 'All' },
    filterPending: { id: 'Menunggu', en: 'Pending' },
    filterApproved: { id: 'Disetujui', en: 'Approved' },
    filterRejected: { id: 'Ditolak', en: 'Rejected' },
    statusPending: { id: 'Menunggu', en: 'Pending' },
    statusApproved: { id: 'Disetujui', en: 'Approved' },
    statusRejected: { id: 'Ditolak', en: 'Rejected' },
    approve: { id: 'Setujui', en: 'Approve' },
    reject: { id: 'Tolak', en: 'Reject' },
    delete: { id: 'Hapus', en: 'Delete' },
    batchLabel: { id: 'Angkatan', en: 'Batch' },
    noRequests: { id: 'Tidak ada permintaan', en: 'No requests' },
    noRequestsDesc: { id: 'Belum ada permintaan akses pada kategori ini', en: 'No access requests in this category yet' },
    confirmReject: { id: 'Yakin ingin menolak permintaan ini?', en: 'Are you sure you want to reject this request?' },
    confirmDelete: { id: 'Hapus permintaan ini permanen?', en: 'Permanently delete this request?' },
    detailInfo: { id: 'Informasi Pemohon', en: 'Applicant Information' },
    submittedAt: { id: 'Diajukan pada', en: 'Submitted at' },
    emailToCopy: { id: 'Email untuk ditambahkan ke Google Drive', en: 'Email to add to Google Drive' },
    addToGDrive: { id: 'Salin email ini dan tambahkan secara manual ke Google Drive koleksi template PKM', en: 'Copy this email and manually add it to the PKM template collection Google Drive' },
    reminderTitle: { id: 'Pengingat:', en: 'Reminder:' },
    reminderDesc: { id: 'Setelah menyetujui permintaan, tambahkan email pemohon secara manual ke Google Drive koleksi template PKM. Klik "Detail" untuk menyalin email.', en: 'After approving a request, manually add the applicant\'s email to the PKM template collection Google Drive. Click "Detail" to copy the email.' },
  },

  // ─── Common ───
  common: {
    loading: { id: 'Memuat...', en: 'Loading...' },
    save: { id: 'Simpan', en: 'Save' },
    cancel: { id: 'Batal', en: 'Cancel' },
    close: { id: 'Tutup', en: 'Close' },
    search: { id: 'Cari', en: 'Search' },
    back: { id: 'Kembali', en: 'Back' },
    optional: { id: 'Opsional', en: 'Optional' },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('pimnas_lang') || 'id';
  });

  useEffect(() => {
    localStorage.setItem('pimnas_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'id' ? 'en' : 'id');
  }, []);

  // t('home.heroTitle1') → returns the string for current lang
  const t = useCallback((key) => {
    const keys = key.split('.');
    let val = translations;
    for (const k of keys) {
      val = val?.[k];
      if (!val) return key; // fallback to key if not found
    }
    return val[lang] || val.id || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
